import React from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'
import { FaHeart } from 'react-icons/fa'
import { BsBoxSeamFill } from "react-icons/bs";
import { FaRoute } from "react-icons/fa";
import { CgArrowTopRight } from "react-icons/cg";
import Marquee from 'react-fast-marquee'

export default function Logistics() {

    const options = [
        {
            title: "OCEAN FREIGHT",
            label: "Sea",
            image: "https://albidayahgroups.com/Media/Logistics/transport%20options01.png",
            height: "h-80",
        },
        {
            title: "AIR FREIGHT",
            label: "Air",
            image: "https://albidayahgroups.com/Media/Logistics/transport%20options02.png",
        },
        {
            title: "LAND EXPRESS",
            label: "Land",
            image: "https://albidayahgroups.com/Media/Logistics/transport%20options03.png",
            height: "h-80",
        },
    ];

    const testimonials = [
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#0D8F94]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FF6557]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FFDF48]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FF6557]",
        },
        // 🔁 Add more testimonial objects here...
    ];

    return (
        <div>
            <div className="relative w-full h-screen">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center scale-x-[-1]"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Logistics/1370.jpg')` }}
                ></div>

                {/* Milled Dark Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

                {/* Text Overlay - Left Side */}
                <div className="relative z-10 flex items-center h-full px-6 md:px-16">
                    <div className="text-white">
                        <FadeInSectionDownToUp>
                            <h1 className="text-6xl max-sm:text-3xl font-bold mb-4 leading-tight">
                                Connecting Destinations,<br />Empowering <span className='text-[#FF6557]'>Business.</span>
                            </h1>
                            <p className="text-lg md:text-xl">
                                Whether you're moving packages locally or managing complex supply chains, we<br className='max-sm:hidden' />
                                make sure your goods arrive safely, securely, and on schedule - every time.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
            <div>
                <div className="text-black w-full px-20 max-sm:px-5 py-10">
                    <FadeInSectionDownToUp>
                        <p className="text-4xl max-sm:text-4xl font-bold mb-4 leading-tight">
                            About<br /> <span className='text-[#023E4E] text-6xl max-sm:text-4xl'>AB-Logistics</span>
                        </p>
                        <p className="text-lg md:text-xl text-justify text-[#420110]">
                            At <span className='text-[#023E4E] font-bold'>AB-Logistics</span>, we pride ourselves on delivering more than just goods - we deliver reliability, speed, and peace of mind. With a remarkable
                            98% on-time delivery success rate, we’ve earned the trust of clients across industries by consistently meeting deadlines and exceeding
                            expectations. Our commitment to operational excellence, real-time tracking, and customer-first service has positioned us as a leading logistics
                            partner for businesses that demand precision and performance. Whether it's local distribution or complex supply chain management, we ensure
                            every shipment arrives safely, efficiently, and right on time.
                        </p>
                    </FadeInSectionDownToUp>
                </div>
            </div>
            <div>
                <div className="flex max-sm:flex-col justify-between items-center max-sm:space-y-8 bg-[#023E4E] rounded-3xl text-white px-20 max-sm:px-5 py-6 mx-20 max-sm:mx-5">
                    {/* Item 1 */}
                    <FadeInSectionDownToUp>
                        <div className="flex items-center gap-3">
                            <div className="bg-white p-2 rounded-full">
                                <FaHeart color="#FF6557" size={30} />
                            </div>
                            <p className="text-2xl leading-snug">
                                98% On-Time <br className='max-sm:hidden' />
                                Delivery Success <br className='max-sm:hidden' />
                                Rate
                            </p>
                        </div>
                    </FadeInSectionDownToUp>

                    {/* Separator */}
                    <div className="h-24 max-sm:h-0.5 w-0.5 max-sm:w-full rounded-full bg-white mx-4" />

                    {/* Item 2 */}
                    <FadeInSectionDownToUp>
                        <div className="flex items-center gap-3">
                            <div className="bg-white p-2 rounded-full">
                                <BsBoxSeamFill color="#FF6557" size={30} />
                            </div>
                            <p className="text-2xl leading-snug">
                                End-to-End <br className='max-sm:hidden' />
                                Logistics Solutions
                            </p>
                        </div>
                    </FadeInSectionDownToUp>

                    {/* Separator */}
                    <div className="h-24 max-sm:h-0.5 w-0.5 max-sm:w-full rounded-full bg-white mx-4" />

                    {/* Item 3 */}
                    <FadeInSectionDownToUp>
                        <div className="flex items-center gap-3">
                            <div className="bg-white p-2 rounded-full">
                                <FaRoute color="#FF6557" size={30} />
                            </div>
                            <p className="text-2xl leading-snug">
                                Real-Time Tracking <br className='max-sm:hidden' />
                                & Transparent <br className='max-sm:hidden' />
                                Updates
                            </p>
                        </div>
                    </FadeInSectionDownToUp>
                </div>
            </div>
            <div>
                <div className='px-20 max-sm:px-5 py-10'>
                    <div>
                        <p className='text-4xl text-[#023E4E] font-bold'>Our Services !</p>
                    </div>
                    <div className='mt-5 p-7 max-sm:p-5 rounded-3xl shadow-2xl border-2'>
                        <div className="flex flex-col sm:flex-row justify-between gap-10">
                            {options.map((option, index) => (
                                <div key={index} className="space-y-3 w-full">
                                    <FadeInSectionDownToUp>
                                        {/* 🖼 Image Wrapper */}
                                        <div className="relative w-full rounded-3xl overflow-hidden">
                                            <img
                                                src={option.image}
                                                alt={option.title}
                                                className={`w-full ${option.height} max-sm:h-full object-cover rounded-3xl`}
                                            />

                                            {/* 🔼 Top Right Arrow */}
                                            <div className="absolute top-3 right-3 bg-white rounded-full p-2 shadow-md">
                                                <CgArrowTopRight size={20} className="text-[#023E4E]" />
                                            </div>

                                            {/* 🏷 Bottom Left Label */}
                                            <div className="absolute bottom-3 left-3 bg-white bg-opacity-90 text-[#023E4E] text-sm font-semibold px-3 py-1 rounded-full shadow">
                                                {option.label}
                                            </div>
                                        </div>
                                    </FadeInSectionDownToUp>

                                    {/* 📦 Title Below Image */}
                                    <p className="font-bold text-[#023E4E] text-2xl">{option.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='px-20 max-sm:px-5 py-10 max-sm:py-5'>
                <div>
                    <FadeInSectionDownToUp>
                        <p className="text-3xl max-sm:text-2xl text-[#420110] font-bold mb-4 leading-tight">
                            What Our Customer’s Says ?
                        </p>
                    </FadeInSectionDownToUp>
                </div>
                {/* <div>
                    <Marquee>
                        <div className='shadow-2xl border-2 rounded-2xl'>
                            <div className='flex justify-center items-start'>
                                <img className='rounded-full w-20' src='https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg' alt='AB-Logistics' />
                                <div>
                                    <p className='font-bold text-xl'>"A Dream Vacation Come True!"</p>
                                    <p>I booked my honeymoon through this website and had
                                        the most amazing experience. From the seamless
                                        booking process to the personalized recommendations,
                                        everything was perfect. The destination was just as
                                        beautiful as promised, and the local guides were
                                        knowledgeable and friendly. Highly recommend!</p>
                                </div>
                            </div>
                        </div>
                        <div className='shadow-2xl border-2 rounded-2xl'>
                            <div className='flex justify-center items-start'>
                                <img className='rounded-full w-20' src='https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg' alt='AB-Logistics' />
                                <div>
                                    <p className='font-bold text-xl'>"A Dream Vacation Come True!"</p>
                                    <p>I booked my honeymoon through this website and had
                                        the most amazing experience. From the seamless
                                        booking process to the personalized recommendations,
                                        everything was perfect. The destination was just as
                                        beautiful as promised, and the local guides were
                                        knowledgeable and friendly. Highly recommend!</p>
                                </div>
                            </div>
                        </div>
                        <div className='shadow-2xl border-2 rounded-2xl'>
                            <div className='flex justify-center items-start'>
                                <img className='rounded-full w-20' src='https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg' alt='AB-Logistics' />
                                <div>
                                    <p className='font-bold text-xl'>"A Dream Vacation Come True!"</p>
                                    <p>I booked my honeymoon through this website and had
                                        the most amazing experience. From the seamless
                                        booking process to the personalized recommendations,
                                        everything was perfect. The destination was just as
                                        beautiful as promised, and the local guides were
                                        knowledgeable and friendly. Highly recommend!</p>
                                </div>
                            </div>
                        </div>
                    </Marquee>
                </div> */}
                <div className='max-sm:pb-20'>
                    <Marquee pauseOnHover={true} speed={50} gradient={false} className="gap-8">
                        {testimonials.map((t, i) => (
                            <div
                                key={i}
                                className="relative border-2 rounded-2xl m-4 p-6 min-w-[400px] max-w-sm"
                            >
                                {/* 👤 Avatar & Content */}
                                <FadeInSectionDownToUp>
                                    <div className="flex items-start gap-4">
                                        <img
                                            className="rounded-full w-20 h-20 object-cover"
                                            src={t.image}
                                            alt={t.name}
                                        />
                                        <div className="text-gray-700">
                                            <p className="font-bold text-lg mb-2">{t.quote}</p>
                                            <p className="text-sm">{t.feedback}</p>
                                        </div>
                                    </div>
                                </FadeInSectionDownToUp>

                                {/* 🎨 Decorative Clip-Path Circle */}
                                <div className={`absolute bottom-0 left-0 w-20 h-20 ${t.colour} z-0 clip-circle rounded-bl-2xl`} />
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </div>
    )
}
